import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import './index.css';
import AppWrapper from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      {/* Wrap the entire app in BrowserRouter */}
      <BrowserRouter>
        <AppWrapper />
      </BrowserRouter>
    </React.StrictMode>
  );
}

reportWebVitals();
